import { call, put, takeLatest } from "redux-saga/effects";
import {
  userLoginApi,
  userLoginWithUserNameApi,
  userLogOutApi,
  getNotificationListApi,
  updateNotificationListApi,
  userForgotPasswordApi,
} from "../requests/userRequests";
import { toast } from "react-toastify";
import { setCookie } from "cookies-next";
import { TOKEN, REFRESHTOKEN } from "../../../utils/localStorage";
import { UserActions } from "../../action-types/userActionTypes";
import { setUserData, isUserLogOut } from "../../actions/userActions";
import { getRoleMastersListApi } from "../requests/mastersRequests";
import {
  setLoaderUserLogin,
  setLoaderUserLogOut,
  setLoaderNotification,
  setNotificationData,
  isForgotPassword,
} from "../../actions/userActions";
import { MastersActions } from "../../action-types/mastersActionTypes";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getAccountDetailsList } from "../../actions/accountAction";

// Login Handler

function* userLoginHandler(action) {
  yield put(setLoaderUserLogin(true));
  // start loader here
  try {
    const { data } = yield call(userLoginApi, action.payload);

    if (data.status) {
      if (data?.data?.active === true) {
        setCookie(TOKEN, data?.tokens?.access?.token);
        setCookie(REFRESHTOKEN, data?.tokens?.refresh?.token);
        yield put(isUserLogOut(false));
        localStorage.setItem("companyID", data?.data?.company_id);
        yield put(
          setUserData({
            userData: data?.data,
          })
        );
        yield put(
          getAccountDetailsList({
            id: data?.data?.id,
          })
        );
        yield put({
          type: MastersActions.GET_ROLE_MASTER_LIST,
        });
        if (data?.data?.role?.name !== "VESSEL_ADMIN") {
          yield put({
            type: UserActions.GET_NOTIFICATION_LIST,
          });
        }
      } else {
        toast.error("Your login is disabled,please contact your administrator");
      }
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderUserLogin(false));
    // handle error
  } finally {
    //stop loader here
    yield put(setLoaderUserLogin(false));
  }
}

function* userLoginWithUserNameHandler(action) {
  // start loader here
  yield put(setLoaderUserLogin(true));
  try {
    const { data } = yield call(userLoginWithUserNameApi, action.payload);

    if (data.status) {
      if (data?.data?.active === true) {
        setCookie(TOKEN, data?.tokens?.access?.token);
        setCookie(REFRESHTOKEN, data?.tokens?.refresh?.token);
        yield put(isUserLogOut(false));
        localStorage.setItem("companyID", data?.data?.company_id);
        yield put(
          setUserData({
            userData: data?.data,
          })
        );
        yield put({
          type: MastersActions.GET_ROLE_MASTER_LIST,
        });
      } else {
        toast.error("Your login is disabled,please contact your administrator");
      }
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderUserLogin(false));
    // handle error
  } finally {
    //stop loader here
    yield put(setLoaderUserLogin(false));
  }
}

// Logout Handler

function* userLogOutHandler(action) {
  yield put(setLoaderUserLogOut(true));
  // start loader here
  try {
    const { data } = yield call(userLogOutApi, action.payload);

    if (data.status) {
      localStorage.clear();
      yield put(isUserLogOut(true));
      toast.success(data.message);
      Cookies.remove(TOKEN);
      Cookies.remove(REFRESHTOKEN);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderUserLogOut(false));
  } finally {
    //stop loader here
    yield put(setLoaderUserLogOut(false));
  }
}

// Forgot Password Handler

function* userForgotPasswordHandler(action) {
  yield put(setLoaderUserLogin(true));
  // start loader here
  try {
    const { data } = yield call(userForgotPasswordApi, action.payload);

    if (data.status) {
      yield put(isForgotPassword(true));
      toast.success(data.message);

    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderUserLogin(false));
  } finally {
    //stop loader here
    yield put(setLoaderUserLogin(false));
  }
}



// Notification Handler

function* userNotificationHandler(action) {
  yield put(setLoaderNotification(true));
  // start loader here
  try {
    const { data } = yield call(getNotificationListApi);
    if (data.status) {
      yield put(setNotificationData(data.data));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderNotification(false));
    // handle error
  } finally {
    //stop loader here
    yield put(setLoaderNotification(false));
  }
}

function* updateNotificationHandler(action) {
  // start loader here
  try {
    const { data } = yield call(updateNotificationListApi, action.payload);
    if (data.status) {
      yield put({
        type: UserActions.GET_NOTIFICATION_LIST,
      });
    }
    // handle response here and set into reducer
  } catch (error) {
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

export default function* userSaga() {
  yield takeLatest(UserActions.USER_LOGIN, userLoginHandler);
  yield takeLatest(
    UserActions.USER_LOGIN_WITH_USERNAME,
    userLoginWithUserNameHandler
  );
  yield takeLatest(UserActions.USER_LOGOUT, userLogOutHandler);
  yield takeLatest(UserActions.USER_FORGOT_PASSWORD, userForgotPasswordHandler);
  yield takeLatest(UserActions.GET_NOTIFICATION_LIST, userNotificationHandler);
  yield takeLatest(
    UserActions.UPDATE_NOTIFICATION_LIST,
    updateNotificationHandler
  );
}
